import React, { Component } from 'react';
import stickybits from 'stickybits';
import dlTrackMediaBannersEvents from 'app/analytics/mediaBannersEventsAnalytics';
import dlTrackPDPEvents, { dlSizeSelectorTracker } from 'app/analytics/pdpEventsAnalytics';
import {
  MINI_WISHLIST_ROOT_ELEMENT,
  TRANSFER_MINI_WISHLIST_ADD,
  TRANSFER_MINI_WISHLIST_REMOVE,
} from 'app/header/miniWishlist/miniWishlistConstants';
import store from './productDetailsStore';
import { fetchProductDetails, updateInWishlistProducts, fetchUserEncodedId } from './productDetailsActions';

const hidePDPComponents = () => {
  // hide other PDP page components, when product was not found
  const selectors = ['.product-desc-wrapper'];

  selectors.forEach(selector => {
    const component = document.querySelector(selector);
    component.style.display = 'none';
  });

  const pdpComponents = document.querySelectorAll('.pdp-component');
  pdpComponents.forEach(component => {
    component.style.display = 'none';
  });
};

const productDetailsHOC = WrappedComponent => {
  class ProductDetails extends Component {
    static getOffset(ref) {
      const elementHeight = ref?.offsetHeight ?? 0;
      const headerHeight = document.querySelector('.header').offsetHeight;
      const viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
      const OFFSET = 50;

      // When productDetails's height is taller than the viewport -
      // block has to be scrollable till it reaches the bottom edge
      // so that only the bottom section is visible during the scroll.
      // Otherwise, productDetails is sticky to the top of the parent.
      return viewportHeight < headerHeight + elementHeight ? (elementHeight - (viewportHeight - OFFSET)) * -1 : OFFSET;
    }

    constructor() {
      super();

      this.state = {
        dataLoaded: false,
      };

      this.refProductDetails = null;
      this.stickyProductDetails = null;

      this.onResize = this.onResize.bind(this);
      this.setProductDetailsRef = this.setProductDetailsRef.bind(this);
    }

    componentDidMount() {
      fetchProductData().then(
        () => {
          this.setState(
            {
              dataLoaded: true,
            },
            () => {
              setTimeout(() => {
                this.setUpStickyProductDetails();
              }, 0);
              window.addEventListener('resize', this.onResize);
              window.addEventListener('hashchange', onHashChange);
              dlTrackMediaBannersEvents();
              dlTrackPDPEvents();
              dlSizeSelectorTracker.dlTrackSizeGuideClick();
            }
          );
        },
        () => {
          this.setState({ dataLoaded: true });
          hidePDPComponents();
        }
      );

      [TRANSFER_MINI_WISHLIST_ADD, TRANSFER_MINI_WISHLIST_REMOVE].forEach(event => {
        MINI_WISHLIST_ROOT_ELEMENT.addEventListener(event, () => {
          updateInWishlistProductsData();
        });
      });

      fetchEncodedId();
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.onResize);
      window.removeEventListener('hashchange', onHashChange);
    }

    onResize() {
      if (this.stickyProductDetails) {
        this.stickyProductDetails.cleanup();
        this.setUpStickyProductDetails();
      }
    }

    setProductDetailsRef(ref) {
      this.refProductDetails = ref;
    }

    setUpStickyProductDetails() {
      this.stickyProductDetails = stickybits(this.refProductDetails, {
        stickyBitStickyOffset: ProductDetails.getOffset(this.refProductDetails),
      });
    }

    render() {
      const { dataLoaded } = this.state;
      return dataLoaded ? <WrappedComponent setProductDetailsRef={this.setProductDetailsRef} /> : null;
    }
  }

  return ProductDetails;
};

export default productDetailsHOC;

function onHashChange() {
  if (window.location.hash) {
    fetchProductData().then(null, () => {
      hidePDPComponents();
    });
  }
}

function fetchProductData() {
  const { pathname, search, hash } = window.location;
  return store.dispatch(fetchProductDetails(pathname + search + hash));
}

function updateInWishlistProductsData() {
  return store.dispatch(updateInWishlistProducts());
}

function fetchEncodedId() {
  return store.dispatch(fetchUserEncodedId());
}
